module.exports = __webpack_public_path__ + "img/calendar_clock.721c48e7.svg";